import React from 'react'
import About from './components/About/About'
import Contact from './components/Contact/Contact'
import Landing from './components/Landing'
import Footer from './components/navigation/Footer'
import Navbar from './components/navigation/Navbar'
import SkipLinks from './components/navigation/SkipLinks'
import Works from './components/Works/Works'
import './css/default.css'

const App = () => {
  return (
    <div className="App">
      <SkipLinks />
      <Navbar />
        <Landing />
          <About />
          <Works />
          <Contact />
      <Footer />
    </div>
  )
}

export default App
